import { useMemo } from "react";
import { array } from "@lcms/helpers";
export function useArray(length) {
    return useMemo(() => array(length), [length]);
}
